<template>
    <div class="panelbox">
        <div class="panelbox-header bg-color-secondary">
            <div class="indent">
                <span />
            </div>
            <header 
                v-bastards 
                v-html="headerText" 
            />
        </div>
        <div class="panelbox-body bg-color-secondary">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        headerText: {
            type: String,
            required: false,
            default: ''
        }
    }
}
</script>

<style lang="scss">
.panelbox {
    $width-desktop: 430px;

    display: inline-block;
    width: 100%;
    max-width: $width-desktop;

    &-header {
        overflow: visible;
        position: relative;
        padding: 18px 0 18px 0;
        margin-left: 20px;

        .indent {
            overflow: hidden;
            position: absolute;
            left: -20px;
            top: 0;
            height: 100%;
            width: 20px;

            &:before,
            &:after {
                content: '';
                background-color: $color-secondary;
                position: absolute;
                left: 0;
                width: 20px;
                height: 100%;
            }

            &:before {
                bottom: calc(50% + 10px);
            }

            &:after {
                top: calc(50% + 10px);
            }

            > span {
                content: '';
                @include size(0);
                @include position-center-vertically();
                position: absolute;
                border-left: 10px solid transparent;
                border-right: 10px solid $color-secondary;
                border-bottom: 10px solid $color-secondary;
                border-top: 10px solid $color-secondary;
                left: 0;
            }
        }

        header {
            font-size: 2.2rem;
            line-height: 2.4rem;
        }
    }

    &-body {
        padding: 22px 33px 30px;
        border-top: 1px solid $color-bg-light;
    }
}
</style>